import Loadable from './Loadable';
import reducer from './modules/preferences.slice';
import saga from './modules/preferences.saga'

export default {
	component: Loadable,
	saga,
	reducer
};